import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@rocco/components/dialog';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import ReturnsPolicyTemplate from './RefundTemplate';
import type { RefundPolicyData } from './RefundPolicy';
import RefundPolicyDialogMobile from './RefundPolicyDialog.mobile';

const RefundPolicyDialog = ({
    open,
    close,
    data,
}: {
    open: boolean;
    close: () => void;
    data: RefundPolicyData;
}) => {
    const { mobile } = useAppDisplayModeContext();

    if (mobile) {
        return (
            <RefundPolicyDialogMobile open={open} close={close} data={data} />
        );
    }

    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && close()}>
            <DialogContent
                spacing="none"
                className="flex max-h-[80vh] max-w-[calc(100vw-2rem)] flex-col rounded-lg sm:max-w-3xl"
            >
                <DialogHeader className="shrink-0 px-8 pb-4 pt-6">
                    <DialogTitle className="text-xl font-semibold">
                        Return and Refund policy
                    </DialogTitle>
                </DialogHeader>
                <div className="min-h-0 flex-1 overflow-y-auto px-8 pb-8">
                    <ReturnsPolicyTemplate data={data} />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default RefundPolicyDialog;
